import { AppRouteNames } from "@/shared/@types";
import { FbsCustomerType } from "@/app/fbs-hub-app/shared/@types";

const ROUTE_PERMISSION_MAP: Record<
  string | symbol,
  (fbsCustomerType: FbsCustomerType) => boolean
> = {
  // accessible to all fbs customer types
  [AppRouteNames.FbsHubStart]: () => true,
  [AppRouteNames.FbsHubDocuments]: () => true,
  [AppRouteNames.FbsHubNotFound]: () => true,
  [AppRouteNames.FbsHubWestfalengasBio]: () => true,

  // accessible to all fbs customer types except multi-meter customers
  [AppRouteNames.FbsHubCheckout]: (fbsCustomerType) =>
    fbsCustomerType !== FbsCustomerType.MultiMeterCustomer,
  [AppRouteNames.FbsHubGasContainers]: (fbsCustomerType) =>
    fbsCustomerType !== FbsCustomerType.MultiMeterCustomer,
  [AppRouteNames.FbsHubOrders]: (fbsCustomerType) =>
    fbsCustomerType !== FbsCustomerType.MultiMeterCustomer,

  // accessible to meter customers only
  [AppRouteNames.FbsHubMeterReport]: (fbsCustomerType) =>
    fbsCustomerType === FbsCustomerType.SingleMeterCustomer ||
    fbsCustomerType === FbsCustomerType.MultiMeterCustomer,
  [AppRouteNames.FbsHubMonthlyPayment]: (fbsCustomerType) =>
    fbsCustomerType === FbsCustomerType.SingleMeterCustomer ||
    fbsCustomerType === FbsCustomerType.MultiMeterCustomer,

  // accessible to order customers only
  [AppRouteNames.FbsHubPriceCockpit]: (fbsCustomerType) =>
    fbsCustomerType === FbsCustomerType.NonBioOrderCustomer ||
    fbsCustomerType === FbsCustomerType.BioOrderCustomer,

  // accessible to bio order customers only
  [AppRouteNames.FbsHubWestfalengasBioTariff]: (fbsCustomerType) =>
    fbsCustomerType === FbsCustomerType.BioOrderCustomer,
};

export const checkFbsPermission = (
  route: string | symbol | undefined,
  fbsCustomerType: FbsCustomerType | undefined,
) => {
  if (!route || !fbsCustomerType) return false;

  const permissionCheck = ROUTE_PERMISSION_MAP[route];
  return permissionCheck ? permissionCheck(fbsCustomerType) : false;
};
